import { render, staticRenderFns } from "./tripComment.vue?vue&type=template&id=1b158ff7&scoped=true&"
import script from "./tripComment.vue?vue&type=script&lang=js&"
export * from "./tripComment.vue?vue&type=script&lang=js&"
import style0 from "./tripComment.vue?vue&type=style&index=0&id=1b158ff7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b158ff7",
  null
  
)

export default component.exports